import { getValueFromToken } from './getValueFromToken';

// eslint-disable-next-line import/prefer-default-export
export const hasSocialMediaTrainingAccess = () => {
  return getValueFromToken('hasSocialMediaTrainingAccess');
};
